import * as React from "react";
import "./loaderSpinner.css";

interface LoaderSpinnerProps {
}

/**
 * Kleiner grauer Button, der aktuell noch rot ist
 */
export class LoaderSpinner extends React.Component<LoaderSpinnerProps> {


    render() {
        return <div className="lds-roller">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    }
}